import { SignalingError } from '@/features/signaling/client'

const SIGNALING_MESSAGES: Record<string, string> = {
  kv_not_bound: '信令存储未绑定，请在 EdgeOne 控制台绑定 ROOM_KV',
  rate_limited: '请求过于频繁，请稍后再试',
  expired: '房间已过期，请重新创建',
  not_found: '房间不存在或已关闭',
  room_full: '房间已被占用。请避免同一浏览器多开标签自动加入，或让 Host 重新创建房间',
  poll_timeout: '等待对方超时，请确认对方已打开链接',
  aborted: '操作已取消',
  invalid_code: '房间短码格式不正确',
  forbidden: '无权操作该房间',
  already_answered: '房间已完成握手，请重新创建',
  no_offer: '对方尚未准备好，请稍后重试',
  code_exhausted: '无法分配房间号，请重试',
  payload_too_large: '请求过大',
  http_error: '网络请求失败',
}

export function humanizeError(err: unknown): string {
  if (err instanceof SignalingError) {
    return SIGNALING_MESSAGES[err.code] || err.message || '信令错误'
  }
  if (err instanceof Error) return err.message || '未知错误'
  return String(err)
}

export function errorToastDescription(err: unknown): string | undefined {
  if (err instanceof SignalingError) {
    const mapped = SIGNALING_MESSAGES[err.code]
    if (mapped && err.message && err.message !== mapped) {
      return `${err.code}`
    }
    return err.code !== 'http_error' ? err.code : undefined
  }
  return undefined
}
